export default function ScoutingReportsStatus({data}) {
	if (data.error)
		return (
			<div role="alert" className="alert alert-warning">
				Relazioni e template non disponibili.{" "}
				<button type="button" onClick={() => data.refresh().catch(() => {})}>
					Riprova
				</button>
			</div>
		);
	if (data.loading)
		return <div role="status">Caricamento relazioni e template…</div>;
	return null;
}
